import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { OrderedType, Unit } from "./Units";
import Button from "./../Button";

export default class UnitsRow extends PureComponent {
  static propTypes = {
    userUnits: PropTypes.object.isRequired,
    onSelectedUnit: PropTypes.func,
    type: PropTypes.string,
    unitOfMeasurements: PropTypes.array
  };

  static defaultProps = {
    onSelectedUnit: null,
    type: "",
    unitOfMeasurements: []
  };

  render() {
    const { type, unitOfMeasurements, userUnits } = this.props;
    const rolls = unitOfMeasurements.find(unit => unit.uomId === Unit.Rolls);

    return (
      <Fragment>
        <th className="units-label">{i18n.t(`box.${type}`)}</th>
        <td className="units-list">
          {unitOfMeasurements.map(unit => {
            const { uomId, uomName } = unit;
            return (
              unit.type === type &&
              unit.uomId !== Unit.Rolls && (
                <Button
                  key={uomId}
                  className={classNames("unit", userUnits[unit.type] === uomId && "--selected")}
                  label={uomName}
                  onClick={() => this.props.onSelectedUnit(uomId, type)}
                />
              )
            );
          })}

          {type === OrderedType.Weight &&
            rolls && (
              <Fragment>
                <span className="separator" />
                <Button
                  keyId={rolls.uomId}
                  className={classNames("unit", userUnits[type] === rolls.uomId && "--selected")}
                  label={rolls.uomName}
                  onClick={() => this.props.onSelectedUnit(rolls.uomId, type)}
                />
              </Fragment>
            )}
        </td>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/UnitsSelector/UnitsRow.js